import React from 'react';
import classnames from 'classnames';
import 'animate.css'
import ScrollAnimation from 'react-animate-on-scroll'

import ghome from './assets/googleAssistant.svg'
import secondBg from './assets/devicesOTTcompos.png'
import styles from './index.module.css';

const Tv = () => {
  return (
    <section className={styles.tv}>

      <div className={classnames(styles.first, styles.container)}>

        <div className={styles.blockText} >
          <h2 className={styles.blockTitle} >Best TV experience&nbsp;...</h2>
          <p className={styles.blockContent} >
            iFeelSmart’s solutions have been designed with operators and service providers to offer the best TV experience for linear and non linear TV content. With a progressive engagement from the TV-centric UX to a more interactive usage, iFeelSmart is making the TV Interface playful, fast and simple.
          </p>
          <p>
            iFeelSmart apps are supporting the most modern features in a multiscreen environment : Live, Guide, Mini-Guide, On Demand, Start-Over, TimeShift, PVR, Network DVR, thir party content integration (like Netflix...). iFeelSmart Solutions have been awarded the « Best TV Experience Enhancement » at TV Connect by industry experts.
          </p>
        </div>
      </div>

      <div className={classnames(styles.second, styles.container)}>
        <div className={styles.blockText}>
          <h2 className={styles.blockTitle}>...&nbsp;across managed and OTT devices&nbsp;...</h2>
          <p className={styles.blockContent}>
            iFeelSmart’s solutions are available on managed devices owned by the operators like
  AndroidTV STB, and also on a large number of OTT TV devices like Amazon FireTV,
  AppleTV, Android SmartTV (like Philips or Sony TVs), and a large number of Android
  streamers.
          </p>
        </div>
        <div>
          <img src={secondBg} alt="" className={styles.img} />
        </div>
      </div>

      <div className={classnames(styles.third, styles.container)}>
        <div className={styles.blockText}>
          <h2 className={styles.blockTitle}>...&nbsp;with natural consumer interaction&nbsp;...</h2>
        </div>
        <div className={classnames(styles.blockText, styles.rowLow)}>
          <p className={styles.blockContent}>
            iFeelSmart has already deployed in the market Google Assistant technology for vocal search but also for vocal TV command. iFeelSmart has made significant investments since several years on natural TV interaction like vocal and gesture control.
          </p>
        </div>
        <div className={styles.ghomeContainer}>
          <div className={styles.ghomeLogoWrapper} >
            <div className={styles.ghomeLogo}>
              <ScrollAnimation
                animateOnce={true} animateIn="fadeInDown"
                delay={1000}>
                <img src={ghome} alt="google home logo" />
              </ScrollAnimation>
            </div>
            <ScrollAnimation animateOnce={true} animateIn="fadeInDown" >
              <p className={styles.question}>"Hey Google resume Point Break"</p>
            </ScrollAnimation>
            <ScrollAnimation className={styles.answer} animateOnce={true} animateIn="fadeInDown" delay={2000}>
              <p>"Alright! Resuming Point Break"</p>
            </ScrollAnimation>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Tv;
